import React from 'react'
import { withIcon } from '../../withIcon'

function EmailIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.66031 6.68905L12 12.2488L20.3397 6.68905C20.1988 6.07943 19.6525 5.625 19 5.625H5C4.34755 5.625 3.80124 6.07943 3.66031 6.68905ZM20.375 8.16782L12.3467 13.52C12.1368 13.66 11.8632 13.66 11.6533 13.52L3.625 8.16782V17C3.625 17.7594 4.24061 18.375 5 18.375H19C19.7594 18.375 20.375 17.7594 20.375 17V8.16782ZM2.375 7C2.375 5.55025 3.55025 4.375 5 4.375H19C20.4497 4.375 21.625 5.55025 21.625 7V17C21.625 18.4497 20.4497 19.625 19 19.625H5C3.55025 19.625 2.375 18.4497 2.375 17V7Z" fill={color}/>
    </svg>
  )
}

export default withIcon(EmailIcon)
